module.exports = [
  {
    path: '/',
    pattern: '/^(?:\\/(?=$))?$/i',
    keys: [],
    page: function page() { return Promise.resolve(require('./pages/home')); },
  },
  {
    path: '/error',
    pattern: '/^\\/error(?:\/(?=$))?$/i',
    keys: [],
    page: function page() { return Promise.resolve(require('./pages/error')); },
  },
  {
    path: '/about',
    pattern: '/^\\/about(?:\/(?=$))?$/i',
    keys: [],
    page: function page() { return new Promise(function (resolve, reject) {
        try {
          require.ensure(['./pages/about'], function (require) {
            resolve(require('./pages/about'));
          });
        } catch (err) {
          reject(err);
        }
      }); },
  },
  {
    path: '/tasks/:status(pending|completed)?',
    pattern: '/^\\/tasks(?:\/((?:pending|completed)))?(?:\/(?=$))?$/i',
    keys: [{"name":"status","prefix":"/","delimiter":"/","optional":true,"repeat":false,"partial":false,"asterisk":false,"pattern":"pending|completed"}],
    page: function page() { return new Promise(function (resolve, reject) {
        try {
          require.ensure(['./pages/home'], function (require) {
            resolve(require('./pages/home'));
          });
        } catch (err) {
          reject(err);
        }
      }); },
  },
  {
    path: '/catalog',
    pattern: '/^\\/catalog(?:\/(?=$))?$/i',
    keys: [],
    page: function page() { return new Promise(function (resolve, reject) {
        try {
          require.ensure(['./pages/catalog'], function (require) {
            resolve(require('./pages/catalog'));
          });
        } catch (err) {
          reject(err);
        }
      }); },
  },
];


/*****************
 ** WEBPACK FOOTER
 ** ./routes.json
 ** module id = 674
 ** module chunks = 0
 **/